/**
 * @file - DeleteProduct.js
 */

// ----- Imports ----- //
import React, { useState } from "react";

import { 
	Button, 
	Modal, 
	ModalOverlay, 
	ModalContent, 
	ModalHeader, 
	ModalFooter, 
	ModalBody, 
	ModalCloseButton,
	Text,
	Input,
	Alert,
	AlertIcon,
	AlertDescription,
} from "@chakra-ui/react";

import useDeleteProduct from "hooks/Product/mutations/useDeleteProduct";

// ----- Exports ----- //
/**
 * @function DeleteProductModal
 * @description - This function is used to create the modal that is used to delete a product.
 * @returns - This function returns the JSX used to create the modal.
 */
const DeleteProduct = ({ isOpen, onClose, product, refetch }) => {

	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);

	const [confirmText, setConfirmText] = useState("");

	const { deleteProduct } = useDeleteProduct();
	/**
	 * @function handleDeleteProduct
	 * @description - This function is used to delete an product from the database.
	 * 
	 * @param {*} e - The event object
	 */
	const handleDeleteProduct = async (e) => {
		e.preventDefault();
		setErrorMsg(null);
		setLoading(true);

		let response = await deleteProduct(product._id);
		if(response.error){
			setErrorMsg(response.error.message);
			setLoading(false);
			return;
		}
		if(response.success){
			setLoading(false);
			await refetch();
			onClose();
		}

	};

	return(
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Delete Product</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text>
						{`Are you sure you want to delete the category: ${product.name}?`}
					</Text>
					<Text>
						This action cannot be undone.
					</Text>
					<Text>
						Type the product's name to confirm.
					</Text>
					<Input
						placeholder="Product Name"
						value={confirmText}
						onChange={(e) => setConfirmText(e.target.value)}
					/>
					{errorMsg && (
						<Alert status="error" mt={4}>
							<AlertIcon />
							<AlertDescription>{errorMsg}</AlertDescription>
						</Alert>
					)}
				</ModalBody>
				<ModalFooter>
					<Button
						variant="primary"
						onClick={handleDeleteProduct}
						isLoading={loading}
						isDisabled={confirmText !== product.name}
					>
						Delete Product
					</Button>
					<Button variant="secondary" onClick={onClose}>
						Cancel
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>		
	);
};

export default DeleteProduct;
